module.exports = __webpack_public_path__ + "img/66.6aa638d3.jpg";